"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _MediaCredits = _interopRequireDefault(require("../MediaCredits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.75em;\n  margin: 0.75em 0 0;\n  padding-left: 0;\n  padding-right: 0;\n  display: block;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0.5em 0;\n  font-size: 1.375em;\n  line-height: 1.1em;\n  font-weight: 400;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 0;\n  padding-right: 0;\n  display: block;\n  margin: 1em 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SpanAbstract = _styledComponents.default.span(_templateObject());

var H3Title = _styledComponents.default.h3(_templateObject2());

var SpanType = _styledComponents.default.span(_templateObject3());

var Video = _styledComponents.default.div(_templateObject4());

var MediaServiceVideo = /*#__PURE__*/function (_Component) {
  _inherits(MediaServiceVideo, _Component);

  var _super = _createSuper(MediaServiceVideo);

  function MediaServiceVideo(props) {
    var _this;

    _classCallCheck(this, MediaServiceVideo);

    _this = _super.call(this, props);
    _this.updateVideoHeight = _this.updateVideoHeight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MediaServiceVideo, [{
    key: "getVideoInformationFromUrl",
    value: function getVideoInformationFromUrl(html) {
      var dom = this.parseHtml(html);
      var src = dom && dom.querySelector('source').getAttribute('src');
      var parts = src.split('/');
      var partsNames = ['version', 'lang', 'id'];
      var partsToReturn = {};
      var partIndex = 0;
      var shouldProcess = false;

      for (var i = 0; i < parts.length; i++) {
        var candidate = parts[i];

        if (shouldProcess) {
          partsToReturn[partsNames[partIndex]] = candidate;
          partIndex++;
        }

        if (candidate.indexOf('cloudfront.net') !== -1) {
          shouldProcess = true;
        }

        if (partIndex === partsNames.length) {
          break;
        }
      }

      return partsToReturn;
    }
  }, {
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    }
  }, {
    key: "updateVideoHeight",
    value: function updateVideoHeight() {
      if (this.videoElement) {
        var box = this.videoWrapperElement.getBoundingClientRect();
        var aspectRatio = 1.77777777778; // 16/9

        if (box.width > 0) {
          var height = box.width / aspectRatio;
          this.videoElement.style.height = height + 'px';
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(this.updateVideoHeight, this.props.updateTimeout);
      window.addEventListener('resize', this.updateVideoHeight);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateVideoHeight();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          item = _this$props.item,
          hideDisclaimer = _this$props.hideDisclaimer,
          hideAbstract = _this$props.hideAbstract,
          hideType = _this$props.hideType,
          mediaServiceUrl = _this$props.mediaServiceUrl,
          mediaHash = _this$props.mediaHash,
          mediaToken = _this$props.mediaToken,
          videoLabel = _this$props.videoLabel;
      var videoParts = this.getVideoInformationFromUrl(item.html);
      var videoUrl = "".concat(mediaServiceUrl, "/html/").concat(mediaToken, "/").concat(videoParts.id, "/").concat(videoParts.lang, "?autostart=false&rt=").concat(mediaToken, "&hash=").concat(mediaHash, "&disclaimer=false");
      var abstract = null;
      var type = null;
      var titleText = null;
      var titleElement = null;

      if (!hideAbstract) {
        var dom = this.parseHtml("<div>".concat(item.html, "</div>"));
        abstract = /*#__PURE__*/_react.default.createElement(SpanAbstract, null, item.abstract.consumer);
        titleText = dom.querySelector('h3').firstChild.nodeValue;
        titleElement = /*#__PURE__*/_react.default.createElement(H3Title, null, dom.querySelector('h3').firstChild.nodeValue);
      }

      if (!hideType) {
        type = /*#__PURE__*/_react.default.createElement(SpanType, null, videoLabel);
      }

      return /*#__PURE__*/_react.default.createElement(Video, {
        ref: function ref(el) {
          _this2.videoWrapperElement = el;
        }
      }, type, titleElement, abstract, /*#__PURE__*/_react.default.createElement(Video, {
        as: "iframe",
        ref: function ref(el) {
          _this2.videoElement = el;
        },
        title: "Play Video ".concat(titleText),
        className: "hw-slide-video",
        src: videoUrl,
        frameBorder: "0",
        scrolling: "no",
        allowFullScreen: true
      }), /*#__PURE__*/_react.default.createElement(_MediaCredits.default, {
        hideDisclaimer: hideDisclaimer,
        asOfDate: item.certifiedDate,
        legal: item.legal || undefined,
        credits: item.credits || undefined,
        transcriptHtml: item.transcript.html
      }));
    }
  }]);

  return MediaServiceVideo;
}(_react.Component);

MediaServiceVideo.propTypes = {
  item: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    legal: _propTypes.default.object,
    html: _propTypes.default.string.isRequired,
    duration: _propTypes.default.string.isRequired,
    transcript: _propTypes.default.shape({
      html: _propTypes.default.string
    }).isRequired
  }).isRequired,
  hideDisclaimer: _propTypes.default.bool,
  hideAbstract: _propTypes.default.bool,
  hideType: _propTypes.default.bool,
  updateTimeout: _propTypes.default.number,
  videoLabel: _propTypes.default.string,
  mediaServiceUrl: _propTypes.default.string,
  mediaHash: _propTypes.default.string,
  mediaToken: _propTypes.default.string
};
MediaServiceVideo.defaultProps = {
  hideDisclaimer: false,
  hideAbstract: false,
  updateTimeout: 0,
  videoLabel: 'Video'
};
var _default = MediaServiceVideo;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/MediaServiceVideo/index.js